import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { withApollo } from "@apollo/client/react/hoc";
import SButton from "styled42/components/SButton";
import { Colors } from "styled42/config";
import { graphQLClientMutationHelper, graphQLQueryHelper } from "utils/graphQL";
import {
  EDIT_CANDIDATE,
  LOGGED_IN_USER_DATA,
  LOGGED_OUT_USER_DATA
} from "screens/LoginRegistration/queries";
import NavHeader from "screens/LoginRegistration/utils/NavHeader";
import SText from "styled42/components/SText";
import OptionComponent from "screens/LoginRegistration/components/utils/OptionComponent";
import { totalExperienceOptions } from "screens/LoginRegistration/components/WorkExperienceComponent/utils";
import ArrowNext from "icons/ArrowNext";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";
import QualificationComponent from "./QualificationComponent";

class ProfessionalDetailComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      state: { user }
    } = props;
    this.state = {
      user: "",
      educationId: "",
      qualification: "",
      // hasWorkExperience: null,
      totalExperience: null
    };
  }

  componentDidMount = () => {
    const {
      state: { user, variant }
    } = this.props;

    const qualification = user?.stakeholder?.educations[0]?.proficiency_level;
    // const hasWorkExperience = user.stakeholder.is_experienced_feedback;
    const totalExperience = user?.stakeholder?.total_experience;
    this.setState({
      user,
      qualification,
      // hasWorkExperience,
      totalExperience
    });

    pushClevertapEvent("Page Load", {
      Current_Page: "New loginRegistration",
      Page_Modal: "Personal details - Page 2",
      Test_Case: variant
    });
  };

  handleStateChange = ({ component, value }) => {
    const {
      state: { variant }
    } = this.props;
    this.setState({
      [component]: value
    });
    pushClevertapEvent("loginRegister Clicks", {
      Page_Modal: "Personal details - Page 2",
      Current_Page: "New loginRegistration",
      Test_Case: variant,
      Type: `Education`
    });
  };

  onNextBtnClickHandler = async () => {
    // call basic details submit handler from utils
    let { user, qualification, totalExperience } = this.state;
    const {
      client,
      goNext,
      state: { variant }
    } = this.props;
    let stakeholderId = user?.stakeholder?.id;

    // If stakeholderId is not found in user -> Again fetch user data
    if (!stakeholderId) {
      const { data } = await graphQLQueryHelper(client)({
        query: LOGGED_OUT_USER_DATA,
        variables: {
          userId: user.id
        }
      });
      if (data && data?.node && data?.node?.stakeholder) {
        user = data.node;
        stakeholderId = data?.node?.stakeholder?.id;
      }
    }
    const educationId = user?.stakeholder?.educations[0]?.id;
    let educationObj = { proficiency_level: qualification };
    if (educationId) educationObj = { ...educationObj, id: educationId };
    const educationPayload = [educationObj];

    const payload = {
      educations: educationPayload,
      // is_experienced_feedback: hasWorkExperience,
      total_experience: totalExperience
    };

    pushClevertapEvent("loginRegister Clicks", {
      Page_Modal: "Personal details - Page 2",
      Current_Page: "New loginRegistration",
      Test_Case: variant,
      Type: `Next`
    });

    const { data, error } = await graphQLClientMutationHelper(client)({
      mutation: EDIT_CANDIDATE,
      variables: {
        payload,
        id: stakeholderId
      },
      refetchQueries: [{ query: LOGGED_IN_USER_DATA }]
    });

    if (error) {
      console.error("error", error);
      return;
    }

    if (data && data.edit) {
      const userData = {
        ...user,
        // full_name: fullName,
        first_name: data.edit.user.first_name,
        last_name: data.edit.user.last_name,
        // gender,
        // date_of_birth: dob,
        stakeholder: {
          ...user?.stakeholder,
          educations: data?.edit?.educations,
          total_experience: data?.edit?.total_experience
        }
      };

      goNext({
        user: userData
      });
    }
  };

  onBackHandler = () => {
    const { goBack } = this.props;
    goBack();
  };

  toggleNextBtn = () => {
    const { qualification, totalExperience } = this.state;
    let isEnabled = false;
    if (
      qualification &&
      // typeof hasWorkExperience === "boolean" &&
      totalExperience !== null
    ) {
      isEnabled = true;
    }
    return isEnabled;
  };

  render() {
    const { qualification, totalExperience } = this.state;
    const {
      state: { variant }
    } = this.props;

    return (
      <View style={styles.root}>
        <NavHeader
          progressStatus={2}
          maxValue={variant === "B" ? 2 : 3}
          // primaryText="Create Account"
          containerStyle={styles.navheader}
          onBack={this.onBackHandler}
        />
        <ScrollView
          style={styles.container}
          showsVerticalScrollIndicator={false}
        >
          <QualificationComponent
            value={qualification}
            handleStateChange={this.handleStateChange}
          />
          <View style={{ marginTop: 30 }}>
            <SText size={16}>
              {VernacManager.translateString("job_interest_work_experience")}{" "}
              <SText style={{ fontWeight: "bold" }}>
                {VernacManager.translateString("job_interest_only_work")}
              </SText>
            </SText>
            <View>
              <OptionComponent
                options={totalExperienceOptions}
                responseValue={totalExperience}
                setResponseValue={(experience) => {
                  //  callPushClevertapEvent(variant, "Total Work Ex select");
                  pushClevertapEvent("loginRegister Clicks", {
                    Page_Modal: "Personal details - Page 2",
                    Current_Page: "New loginRegistration",
                    Test_Case: variant,
                    Type: "Work Experience"
                  });
                  const newStateObj = { totalExperience: experience.value };
                  this.setState(newStateObj);
                }}
              />
              {/* <SRadioField
                label="Yes"
                checked={hasWorkExperience}
                onChange={(value) => {
                  this.setState({
                    hasWorkExperience: true
                  });
                }}
              />
              <SRadioField
                label="No"
                checked={!hasWorkExperience}
                onChange={(value) => {
                  this.setState({
                    hasWorkExperience: false
                  });
                }}
              /> */}
            </View>
          </View>
        </ScrollView>
        <View style={styles.footer}>
          <SButton
            type="primary"
            text={VernacManager.translateString("generic_next")}
            suffixIcon={ArrowNext}
            disabled={!this.toggleNextBtn()}
            onClick={this.onNextBtnClickHandler}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    height: "100%",
    backgroundColor: "transparent"
  },
  container: {
    marginTop: 20,
    marginHorizontal: 16
  },
  navheader: {
    backgroundColor: "transparent" // Colors.White[1]
  },
  footer: {
    width: "100%",
    padding: 16,
    backgroundColor: Colors.White[1]
  }
});

export default withApollo(ProfessionalDetailComponent);
